export { FormItemRect, type FormItemRectProps, type Rect } from "./FormItemRect";